import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const StyledFooter = styled.footer`
   font-family: 'Righteous', serif;
   font-size: 0.6em;
   color: var(--footer-text-color);

   span {
      opacity: 0.5;
   }

   span:hover {
      opacity: 1;
   }
`

const Footer = ({ text }) => (
   <StyledFooter>
      <span>{text}</span>
   </StyledFooter>
)

Footer.propTypes = {
   text: PropTypes.string,
}

Footer.defaultProps = {
   text: `© ${new Date().getFullYear()} Build Like Beavers® Ltd. UK registered 12548284.`,
}

export default Footer
